import React from 'react';
import MarketingLayout from './Layouts/MarketingLayout';
import { Link } from '@inertiajs/react';

export default function Solutions({ solutions }) {
  // Helper to strip HTML tags for card descriptions
  const stripHtml = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  return (
    <MarketingLayout title="Solutions Library">
      {/* Hero Header */}
      <section className="spx-hero" style={{ paddingBottom: '48px' }}>
        <div className="spx-container animate-fade-in">
          <span className="spx-badge spx-badge-blue" style={{ marginBottom: '16px' }}>Product suites</span>
          <h1 className="spx-title-large">Operational suites built for active school management</h1>
          <p className="spx-body-lead" style={{ maxWidth: '640px', margin: '0 auto' }}>
            Choose the specific suite your school requires today. Each solution integrates cleanly with the core platform and can be staged over multiple academic terms.
          </p>
        </div>
      </section>

      {/* Solutions Grid */}
      <section className="spx-section" style={{ backgroundColor: 'var(--bg-secondary)', borderTop: '1px solid var(--border-primary)' }}>
        <div className="spx-container">
          <div className="spx-solutions-list">
            {solutions && solutions.map((sol) => (
              <div 
                key={sol.id} 
                className="spx-glass-card" 
                style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'space-between',
                  height: '100%' 
                }}
              >
                <div>
                  <div style={{ 
                    width: '56px', 
                    height: '56px', 
                    borderRadius: 'var(--border-radius-md)', 
                    backgroundColor: 'var(--accent-blue-light)', 
                    color: 'var(--accent-blue)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    fontSize: '24px',
                    marginBottom: '24px' 
                  }}>
                    <i className={sol.icon || 'fas fa-cubes'}></i>
                  </div>
                  
                  <h3 className="spx-title-small" style={{ fontSize: '22px', marginBottom: '16px' }}>{sol.label}</h3>
                  <p style={{ 
                    color: 'var(--text-secondary)', 
                    fontSize: '15px', 
                    lineHeight: '1.6', 
                    marginBottom: '24px',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden' 
                  }}>
                    {stripHtml(sol.overview)}
                  </p>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid var(--border-primary)', paddingTop: '20px' }}>
                  <span style={{ fontSize: '13px', color: 'var(--text-tertiary)', fontWeight: '600', textTransform: 'uppercase' }}>
                    {sol.is_band_based ? 'Capacity-Scaled' : 'Flat-Rate'}
                  </span>
                  
                  <Link 
                    href={`/solutions/${sol.slug}`} 
                    className="spx-btn spx-btn-text" 
                    style={{ fontWeight: '700', paddingRight: 0 }}
                  >
                    View Details <i className="fas fa-chevron-right" style={{ fontSize: '12px', marginLeft: '4px' }}></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Crosslink to Pricing */}
      <section className="spx-section" style={{ borderTop: '1px solid var(--border-primary)' }}>
        <div className="spx-container text-center">
          <h3 className="spx-title-medium" style={{ fontSize: '28px', marginBottom: '16px' }}>Want to calculate the total termly cost?</h3>
          <p className="spx-body-lead" style={{ maxWidth: '600px', margin: '0 auto 32px auto', fontSize: '16px' }}>
            Use our interactive quote builder to estimate price options depending on your active student count and module selections.
          </p>
          <Link href="/pricing" className="spx-btn spx-btn-primary">
            Build Custom Estimate <i className="fas fa-coins"></i>
          </Link>
        </div>
      </section>
    </MarketingLayout>
  );
}
